import styled from "@emotion/styled";
import { fontFredoka } from "@product/scmp-sdk";

import { AppFooter } from "scmp-app/components/app-footer";
import { Events } from "scmp-app/components/posties/events";
import { setFullViewportWidthStyles } from "scmp-app/lib/styles";

import CarIcon from "./footer-car.svg?url";
import WifiIcon from "./footer-wifi.svg?url";
import LineDesktopIcon from "./line-desktop.svg?url";
import LineLargeDesktopIcon from "./line-large-desktop.svg?url";
import LineTabletIcon from "./line-tablet.svg?url";
import LineIcon from "./line.svg?url";

export const Event = styled(Events)`
  position: relative;

  display: block;
`;

export const Line = styled.div`
  display: block;

  inline-size: calc(100% - 48px);
  block-size: 12px;
  max-inline-size: 518px;
  margin-block: 32px;
  margin-inline: auto;
  padding-inline: 24px;

  background-image: url(${LineIcon});
  background-position: center;
  background-size: cover;

  ${props => props.theme.breakpoints.up("tablet")} {
    block-size: 8px;
    margin-block-end: 48px;
    padding: 0;

    background-image: url(${LineTabletIcon});
  }
  ${props => props.theme.breakpoints.up("desktop")} {
    block-size: 12px;
    max-inline-size: 680px;

    background-image: url(${LineDesktopIcon});
  }
  ${props => props.theme.breakpoints.up("largeDesktop")} {
    block-size: 16px;
    max-inline-size: 910px;

    background-image: url(${LineLargeDesktopIcon});
  }
`;

export const PageContainer = styled.div`
  ${setFullViewportWidthStyles()}
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${props => props.theme.breakpoints.up("tablet")} {
    padding-block-end: 107px;
  }
  ${props => props.theme.breakpoints.up("desktop")} {
    padding-block-end: 123px;
  }
  ${props => props.theme.breakpoints.up("largeDesktop")} {
    padding-block-end: 133px;
  }
`;

export const StyledLoading = styled.div`
  margin-block: 32px;

  color: #999999;
  font-weight: 600;
  font-size: 24px;
  font-family: ${fontFredoka};
  line-height: 38px;
  text-align: center;
`;

export const StyledAppFooter = styled(AppFooter)``;

export const MobileCar = styled.div`
  display: flex;
  flex-direction: column;

  inline-size: 100%;
  margin-block-start: 63px;
  ${props => props.theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const Car = styled.div`
  inline-size: 100%;
  block-size: 76.3px;

  background-image: url(${CarIcon});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 272px 76.3px;
`;

export const Wifi = styled.div`
  inline-size: 100%;
  block-size: 63.82px;

  background-image: url(${WifiIcon});
  background-repeat: no-repeat;
  background-position: calc(50% + 52px) center;
  background-size: 67.3px 63.82px;
`;
